import { useCallback, useEffect } from 'react';
import { useUpdateEffect } from 'react-use';
import syncStateWithUrl from '../tools/syncStateWithUrl';
import updateUrl from '../tools/updateUrl';

/**
 * Custom hook to synchronize URL with state parameters.
 * @param {Object} parameters - The parameters to sync with the URL.
 * @param {Function} dispatch - The dispatch function to update state.
 * @param {string} parameters.url - The base URL to update.
 */
const useUrlSync = (parameters, dispatch) => {
  const handleHistoryNavigation = useCallback(() => {
    syncStateWithUrl(dispatch);
  }, [dispatch]);

  useEffect(() => {
    window.addEventListener('popstate', handleHistoryNavigation);
    return () => {
      window.removeEventListener('popstate', handleHistoryNavigation);
    };
  }, [handleHistoryNavigation]);

  useUpdateEffect(() => {
    const { url } = parameters;
    const path = url ? url.split('?')[0] : url;
    if (!parameters.historyNavigation) {
      updateUrl(
        { ...parameters },
        ...(path ? [path] : []),
      );
    }
  }, [parameters]);
};

export default useUrlSync;
